module.exports = __webpack_public_path__ + "img/list3.365781d0.png";